export enum ERailroadVehicleCoupler {
  RVC_FRONT,
  RVC_BACK,
}

export const ERailroadVehicleCouplerDisplayName = {
  [ERailroadVehicleCoupler.RVC_FRONT]: 'Front',
  [ERailroadVehicleCoupler.RVC_BACK]: 'Back',
};
